module.exports = __webpack_public_path__ + "static/media/Watertower_5.838fed05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/watertower/Watertower_5.png
// module id = 1277
// module chunks = 3